import {createContext} from "react";

export const Fl = createContext(null);